import { ConstructionComponentInfo } from "@interfaces/constructor/constructor";
import { KeyValueSet } from "@interfaces/helpers";
import { ErrorMessageInfo, FieldInfo, FieldValueInfo, ReCAPTCHAInfo, SubmitInfo } from "@constructor/components/core/forms";
import { LoginServerSelectorInfo, GameServerSelectorInfo, AccountSelectorInfo, CharacterSelectorInfo } from "@constructor/components/core/forms/selectors";
import { AccountsListInfo, CharactersListInfo, GameServersListInfo, LoginServersListInfo, AccountsCountInfo, CharactersCountInfo } from "@constructor/components/core/forms/lists";
import { DropdownInfo, DropdownOptionInfo, DropdownValueInfo } from "@constructor/components/core/forms/dropdown";



const infos: KeyValueSet<ConstructionComponentInfo> = {
    FieldInfo,
    FieldValueInfo,
    SubmitInfo,
    ReCAPTCHAInfo,
    ErrorMessageInfo,

    LoginServerSelectorInfo,
    GameServerSelectorInfo,
    AccountSelectorInfo,
    CharacterSelectorInfo,

    AccountsListInfo,
    CharactersListInfo,
    GameServersListInfo,
    LoginServersListInfo,

    AccountsCountInfo,
    CharactersCountInfo,

    DropdownInfo,
    DropdownOptionInfo,
    DropdownValueInfo
}

export default infos;